import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isLoggedIn } from '../utils/auth';
import MainLayout from '../layouts/MainLayout';

export default function PrivateRoute() {
    const location = useLocation();

    return isLoggedIn() ? (
        <MainLayout>
            <Outlet />
        </MainLayout>
    ) : (
        <Navigate to={'/'} state={{ from: location }} replace />
    );
}
